import { TRANSFER_TASK, LIST_DEPARTMENT } from '../../api/task_transfer';

const state = {
	listDepartment: [],
};

const mutations = {
	SET_LIST_DEPARTMENT(state, payload) {
		state.listDepartment = payload;
	},
};

const actions = {
	GET_LIST_DEPARTMENT: async ({ commit }) => {
		const resp = await LIST_DEPARTMENT();
		const data = resp.data.data;
		commit('SET_LIST_DEPARTMENT', data);
	},
	TRANSFER_TASK: async ({}, payload) => {
		const { task_id, plan_id } = payload;
		const response = await TRANSFER_TASK(task_id, plan_id);
		return response;
	},
};

const getters = {
	listDepartment: (states) => states.listDepartment,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
